<template>
  <el-row style="padding-bottom: 20px">
    <el-col :span="24">

      <div v-show=" !mobiePhoneShow || !showNewsDetail "  class="my-swiper-box" >

        <div class="my-swiper-box-bg" :style="{
              '--bgImage': 'url(' + imgserver + VirtualImage + ')',
            }"  ></div>

        <swiper  v-if="bannerList.length > 0" :options="swiperOption" ref="mySwiper" class="custom-carousel"  >
          <swiper-slide v-for="(item, index) in bannerList"
                        :key="'swiper-' + index" :index="'swiper-' + index"    :style="{height:bannerHeight + 'rem'}"  >
            <div
                class="banner-block background-image cur-pointer"
            >
              <div class="background-image-bgbox">
                <el-image class="background-image-bg" :src="imgserver + item.url" fit="cover"></el-image>
              </div>

            </div>

          </swiper-slide>
          <div class="swiper-pagination" slot="pagination"></div>
          <div class="swiper-button-next" @click='swiperNext' slot="button-prev">
            <i class="el-icon-arrow-right" style="color: #fff;"></i>
          </div>
          <div class="swiper-button-prev" @click='swiperPrev' slot="button-next">
            <i class="el-icon-arrow-left" style="color: #fff;" ></i>
          </div>
        </swiper>

      </div>



    </el-col>

    <!-- 面包屑及搜索栏 -->
    <el-col v-if=" !mobiePhoneShow " :span="24" class="breadcrumb-search">
      <!-- 面包屑 -->
      <div  class="breadcrumb-block">
        <div class="breadcrumb-block-content">
          <el-breadcrumb separator=">">
            <el-breadcrumb-item :to="{ path: '/' }"
            ><span>网站首页</span></el-breadcrumb-item
            >
            <el-breadcrumb-item><span>学校概况</span></el-breadcrumb-item>

            <div class="custom-bead-box"  >
              <div class="bead-box-item" @click="clickAsidMenu(item.id)" :class="asidId == item.id?'bead-box-item-active':''" v-for="(item,index) in functionList" :key="item.id">
                <div >{{ item.name }}</div>
                <div v-if="index < functionList.length - 1" class="bead-box-item-line"></div>
              </div>
            </div>
          </el-breadcrumb>
        </div>
      </div>
    </el-col>

    <!-- 面包屑及搜索栏 -->
    <el-col class="common-block page-content">
<!--      <div class="asid-menu-block" v-if="!mobiePhoneShow">-->
<!--        <el-menu :default-active="asidId" @select="clickAsidMenu">-->
<!--          <div v-for="item in functionList" :key="item.id">-->
<!--            <el-menu-item class="asid-menu-item" :index="item.id.toString()">-->
<!--              <span slot="title">{{ item.name }}</span>-->
<!--            </el-menu-item>-->
<!--          </div>-->
<!--        </el-menu>-->
<!--      </div>-->

      <div class="asid-hor-menu-block" v-if="mobiePhoneShow" >
        <el-menu v-if="false"
            :default-active="asidId"
            class="el-menu-demo"
            mode="horizontal"
            @select="clickAsidMenu"
        >
          <div
              v-for="item in functionList"
              :key="item.id"
              style="display: inline-block"
          >
            <el-menu-item class="asid-menu-item" :index="item.id.toString()">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </el-menu>
      </div>

      <div class="content-block" v-if="!showNewsDetail">
       <div class="content-block-layout">
         <div
             v-for="item in dataList"
             :key="item.id"
             class="content-block-item cur-pointer"
             @click="toNewsDetail(item)"
         >
           <div class="content-icon" :style="item.imgObj"></div>
           <div class="content-item">
             <div class="title-detail">
               <div class="content-item-title ellipsis">{{ item.title }}</div>
               <div class="content-item-detail">
                 {{ item.remark }}
               </div>
             </div>
             <div class="content-item-opTime">
               {{ item.opTime.slice(5, 10) }}
             </div>
           </div>
         </div>
         <div class="pagination-block" v-if="!showNewsDetail && total !== 0">
           <el-pagination
               @current-change="handlePageChange"
               :current-page="currentPage"
               :page-size="currentSize"
               layout="total, pager, jumper"
               :total="total"
               :small="pageSmallBool"
               :pager-count="pagerCount"
           >
           </el-pagination>
         </div>
       </div>
      </div>

      <div v-show="showNewsDetail" class="rich-content" >
        <div class="rich-box">
          <div class="html-title">{{contentsTitle}}</div>
          <div id="cus-rick-box" class="html-block">
            <div v-html="contents"></div>
          </div>
        </div>

        <div :style="{width: richContentWidth}"  class="rich-swiper-box">
          <swiper  v-if="bannerListRich.length > 0" :options="swiperOptionRich" ref="mySwiperRich" class="rich-custom-carousel"  >
            <swiper-slide v-for="(item, index) in bannerListRich"
                          :key="'rich-' + index" :index="'rich-' + index"   :style="{height:richBannerHeight + 'rem'}"  >
              <div
                  class="rich-banner-block cur-pointer"
              >
                <div class="rich-background-image-bgbox">
                  <img  class="rich-background-image-bg" style="object-fit: cover;" :src="imgserver + item.url"  alt="">
                </div>

              </div>

            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
          </swiper>

        </div>

      </div>


    </el-col>
  </el-row>
</template>

<script>
import {
  getBannerListApi,
  getFunctionListApi,
  getDataListApi,
  getNewsInfoApi,
} from "@/api/homeApi";
import {swiper, swiperSlide} from "vue-awesome-swiper";
import index from "vue-lazyload";
import {nextTick} from "vue";
import shareMethods from "@/common/shareMethods";

let _self = "";
export default {
  name: "home",
  components: {swiper, swiperSlide},
  data() {
    return {
      funcId: "3",
      asidId: "",
      currentPage: 1,
      currentSize: 10,
      total: 0,
      searchValue: "",
      bannerList: [],
      bannerListRich: [],
      dataList: [],
      functionList: [],
      dataIndex: 0,
      routerName: "",
      showNewsDetail: false,
      contents: "",
      bannerHeight: 22.9,
      openType: 0,
      mobiePhoneShow: true,
      pageSmallBool: false,
      pagerCount: 7,
      contentsTitle: "",

      swiperOption: {
        init:false,
        preloadImages:false,
        initialSlide:0,
        loopAdditionalSlides: 5,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。

        },
        // notNextTick:true,
        autoplay: false,
        loop: true,

      },
      swiperOptionRich: {
        init:false,
        preloadImages: true,
        initialSlide: 0,
        loopAdditionalSlides: 10,
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        observeParents:true,//修改swiper的父元素时，自动初始化swiper
        pagination:{
          el:'.swiper-pagination',
          nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
          prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。

        },
        // notNextTick:true,
        autoplay: true,
        loop: true,
        on: {
          click(e){
            if(e.target.className === "rich-background-image-bg"){
              if(_self.bannerListRich[this.realIndex] && _self.bannerListRich[this.realIndex].jumpPage){
                window.open(_self.bannerListRich[this.realIndex].jumpPage,"_blank")
              }
            }

          }
        }

      },
      richBannerHeight: 33.75,
      richContentWidth: 0,
      currentInfo: {},


    };
  },
  mixins: [shareMethods],
  created() {

    let imgUrl = this.showNewsDetail?this.imgserver + this.currentInfo.picUrl:"https://www.csysedu.com/favicon.png";
    let linkUrl = window.location.href ;
    let desc = this.showNewsDetail?this.currentInfo.remark: "长沙市唯上商务科技学校";
    let title = this.showNewsDetail?this.currentInfo.title: "长沙市唯上商务科技学校";

    this.share(imgUrl, linkUrl,desc, title );

    _self = this;

    var tmpList = window.location.href.split("id=");
    if (tmpList.length == 1) {
    } else {
      this.asidId = tmpList[1].split("&")[0];
    }

    this.openType = this.$route.query.type;
    this.getFuncList();
    if (this.openType == 2) {
      getNewsInfoApi(this.$route.query.id + "", this.$route.query.newsId).then(
        (res) => {
          this.toNewsDetail(res.data);
        }
      );
    }

    getBannerListApi(this.funcId).then((res) => {
      this.bannerList = res.data;

      this.swiperOption.autoplay = this.bannerList.length == 1?false:true;

      setTimeout(() => {
        this.$nextTick(() => {
          // 确保DOM更新后初始化Swiper
          this.swiper.init();

        });
      }, 500)

    });

    this.handleResize();
  },
  methods: {
    index() {
      return index
    },
    handleResize() {
      var html = document.getElementsByTagName("html")[0];
      var oWidth =
        document.body.clientWidth || document.documentElement.clientWidth;
      // 这里的750是指设计图的大小,自己根据实际情况改变
      html.style.fontSize = (oWidth / 1440) * 10 + "px";
      this.mobiePhoneShow = oWidth <= 768 ? true : false;
      if (oWidth < 1439) {
        // 600到1439像素之间的样式处理
        this.bannerHeight = 27.48;
        this.pageSmallBool = true;
        this.pagerCount = 5;
      } else {
        this.bannerHeight = 22.9;
        this.pageSmallBool = false;
        this.pagerCount = 7;
      }

    },

    getDataList(page, size, funcId, searchValue) {
      getDataListApi(page, size, funcId, searchValue).then((res) => {
        this.dataList = res.rows;
        this.dataList.forEach((item, index) => {
          var imgUrl = this.imgserver + item.picUrl;
          if (item.imgConfig !== null) {
            if (item.imgConfig == 0) {
              this.dataList[index].imgObj = {
                backgroundImage: "url(" + imgUrl + ")",
                backgroundSize: "cover",
              };
            } else if (item.imgConfig == 1) {
              this.dataList[index].imgObj = {
                backgroundSize: "contain",
              };
            } else if (item.imgConfig == 2) {
              this.dataList[index].imgObj = {
                backgroundSize: "cover",
              };
            } else if (item.imgConfig == 3) {
              this.dataList[index].imgObj = {
                backgroundRepeat: "repeat-x",
              };
            } else if (item.imgConfig == 4) {
              this.dataList[index].imgObj = {
                backgroundPosition: "center",
              };
            }
          } else {
            this.dataList[index].imgObj = {
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            };
          }
          if (item.picUrl === null || item.picUrl === "") {

            this.dataList[index].imgObj = {
              backgroundSize: "contain",
              backgroundRepeat: "no-repeat",
            };

            this.dataList[index].imgObj.backgroundImage =
              "url(" + require("../assets/img/defalutIcon.jpeg") + ")";

            this.dataList[index].imgObj.backgroundPosition = "50%";

          } else {
            this.dataList[index].imgObj.backgroundImage =
              "url(" + this.imgserver + item.picUrl + ")";
          }
        });
        if (this.asidId == 4 || this.asidId == 5) {
          this.toNewsDetail(this.dataList[0]);
        }
        this.total = res.total;
      });
    },
    getFuncList() {
      getFunctionListApi(this.funcId).then((res) => {
        if (res.data.length > 0) {
          this.functionList = res.data;
          if (this.asidId !== 0) {
            this.functionList.forEach((item, index) => {
              if (this.asidId == item.id) this.routerName = item.name;
            });
          }
          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        } else {
          this.asidId = this.funcId.toString();
          this.MainMenuList.forEach((item, index) => {
            if (item.id == this.funcId) {
              this.functionList[0] = item;
            }
          });
          this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
        }
      });

    },

    clickAsidMenu(index) {
      this.openType = 0;
      this.searchValue = "";
      this.showNewsDetail = false;

     this.$nextTick(() => {
       this.$router.push({
         path: "/schoolProfile",
         query: { id: index, time: new Date().getTime() },
       });

     })

    },
    handlePageChange(val) {
      this.currentPage = val;
      window.scrollTo(0, 0);
      this.getDataList(this.currentPage, this.currentSize, this.asidId, "");
    },

    toNewsDetail(item) {
      this.$router.push({
        path: "/schoolProfile",
        query: { id: item.funcId, type: 2, newsId: item.id   },
      });
      if (item && item.source) {
        window.open(item.source, "_blank");
      } else {
        this.showNewsDetail = true;

        this.currentInfo = item;

        let imgUrl = this.showNewsDetail?this.currentInfo.picUrl?this.imgserver + this.currentInfo.picUrl:"https://www.csysedu.com/favicon.png":"https://www.csysedu.com/favicon.png";
        let linkUrl = window.location.href ;
        let desc = this.showNewsDetail?this.currentInfo.remark: "长沙市唯上商务科技学校";
        let title = this.showNewsDetail?this.currentInfo.title: "长沙市唯上商务科技学校";

        this.share(imgUrl, linkUrl,desc, title );

        var tmpcontents = item.detail;
        // let r = RegExp(/<[(img|iframe)]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        // 获取文本中style部分
        var reg = RegExp(/<iframe\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        var matchres = tmpcontents.match(reg);
        // 获取style部分中width部分
        var widthReg = RegExp(/\bwidth\b\:\s+(.*?)\;/g);
        // 获取style部分中height部分
        var heightReg = RegExp(/\bheight\b\:+\s+(.*?)\;/g);
        var imglength = this.mobiePhoneShow ? "128rem" : "100%";
        if (matchres) {
          matchres.forEach((item, index) => {
            var innnermatchres = item.match(/(style=\")+\s*(.*?)\"/g);
            innnermatchres.forEach((inneritem, index) => {
              var widthMatch = inneritem.match(widthReg);
              var heightMatch = inneritem.match(heightReg);
              if (widthMatch && heightMatch) {
                var realwidth = widthMatch[0].match(/\d+/g);
                var realheight = heightMatch[0].match(/\d+/g);
                var finalheight;
                if (realwidth && realheight) {
                  finalheight =
                      (realheight[0] / realwidth[0]) * (this.mobiePhoneShow ? "144" : "105.6") + "rem";
                }
                let _str =
                  'style="width:' +
                  imglength +
                  ";height:" +
                  finalheight +
                  ';text-align:center;"'; //追加之后的img
                tmpcontents = tmpcontents.replace(inneritem, _str);
              }
            });
          });
          // 获取style部分中width部分
        }
        let r = RegExp(/<img\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        let matchresArray = tmpcontents.match(r); //返回数组['<img ... />','<img ... />']
        // 判断标签是否含有style，含有替换
        // (?<=<p\s+style=").*(?=">)
        if (matchresArray && matchresArray.length > 0) {
          matchresArray.forEach((item, index) => {
            let len = item.length;
            if (item.indexOf("style") < 0) {
              // 不含style 新增
              let _newStyleStr =
                item.slice(0, len - 2) +
                '" style="max-width: 100%  !important; width: 100%;height:auto !important;text-align:center;"/>'; //追加之后的img
              tmpcontents = tmpcontents.replace(item, _newStyleStr);
            } else {
              var startStyleIndex = item.indexOf("style") + 7;
              var endStyleIndex = item.indexOf('"', startStyleIndex);
              let _styleStr =
                "width:" +
                imglength +
                ";max-width: 100%; height:auto !important;text-align:center;";
              // 判断标签是否含有style，含有替换
              tmpcontents = tmpcontents.replace(
                item.slice(startStyleIndex, endStyleIndex),
                _styleStr
              );
            }
          });
        }

        let tableReg = RegExp(/<table\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g);
        let tableMatchresArray = tmpcontents.match(tableReg); //返回数组['<img ... />','<img ... />']
        if (tableMatchresArray && tableMatchresArray.length > 0) {
          tableMatchresArray.forEach((item, index) => {
            let len = item.length;
            if (item.indexOf("style") < 0) {
              // 不含style 新增
              let _newStyleStr =
                item.slice(0, len - 2) +
                '" style="max-width: 100%  !important; width: 120rem !important;height:auto !important;text-align:center;"/>'; //追加之后的img
              tmpcontents = tmpcontents.replace(item, _newStyleStr);
            } else {
              var startStyleIndex = item.indexOf("style") + 7;
              var endStyleIndex = item.indexOf('"', startStyleIndex);
              let _styleStr =
                "width:" +
                imglength +
                ";max-width: 100%; height:auto !important;text-align:center;";
              // 判断标签是否含有style，含有替换
              tmpcontents = tmpcontents.replace(
                item.slice(startStyleIndex, endStyleIndex),
                _styleStr
              );
            }
          });
        }
        // 处理span 字号
        if (this.mobiePhoneShow == true) {
          let spanReg = RegExp(
            /[<p|<span｜<td｜<div]+\s+(.*?)(?<id>\w*?)[\s'"](.*?)>/g
          );
          let spanMatchresArray = tmpcontents.match(spanReg);
          if (spanMatchresArray && spanMatchresArray.length > 0) {
            console.log(spanMatchresArray);
            spanMatchresArray.forEach((item, index) => {
              let len = item.length;
              if (item.indexOf("style") < 0) {
                // 不含style 新增
                let _newStyleStr =
                  item.slice(0, len - 2) +
                  '" style="font-size: 12px !important;"/>'; //追加之后的img'; //追加之后的img
                tmpcontents = tmpcontents.replace(item, _newStyleStr);
              } else {
                // 获取span中style的index
                var startStyleIndex =
                  tmpcontents
                    .slice(0, tmpcontents.indexOf(item) + item.length)
                    .indexOf("style", tmpcontents.indexOf(item)) + 7;
                let _styleStr = "font-size: 12px !important;";
                tmpcontents =
                  tmpcontents.slice(0, startStyleIndex) +
                  _styleStr +
                  tmpcontents.slice(startStyleIndex);
              }
            });
          }
        }
        this.contentsTitle = item.title;
        this.contents = tmpcontents;

        setTimeout(() => {
          getBannerListApi(34 ).then((res) => {
            this.bannerListRich = res.data;

            this.swiperOptionRich.autoplay = this.bannerListRich.length == 1?false:true;

            if(this.bannerListRich.length > 0){
              this.$nextTick(() => {

                let richContent = document.getElementsByClassName("rich-content")[0];
                this.richContentWidth = richContent.offsetWidth > 1200?  (96*0.75)+ "rem": richContent.offsetWidth + "px";

                // 确保DOM更新后初始化Swiper
                this.swiperRich.init();

              });
            }

          });
        }, 500)

        nextTick(() => {
          const rickBox = document.getElementById("cus-rick-box");

          let iframeList = rickBox.getElementsByTagName("iframe")

          let rickBoxWidth =  rickBox.offsetWidth > 1076?1076:rickBox.offsetWidth - 50;
          let frameHeight = 768;
          if( rickBoxWidth <= 375){
            frameHeight = 200;
          }else {
            frameHeight = 400;
          }

          for (let i = 0; i < iframeList.length; i++) {
            let iframe = iframeList[i];
            iframe.style.width = rickBoxWidth  + "px !important";
            iframe.style.height = frameHeight + "px !important";
            iframe.style.display = "block";
            iframe.style.margin = "0 auto";

            // //获取iframe的高度，宽度
            // let aWindow = iframe.contentWindow;
            // let aWindowHeight =
            //     aWindow .document.documentElement.scrollHeight ||
            //     aWindow .document.body.scrollHeight;
            //
            // let aWindowWidth =
            //     aWindow .document.documentElement.scrollWidth ||
            //     aWindow .document.body.scrollWidth;
            //
            //
            // //计算满屏width的值
            // let rickBoxWidth =  rickBox.offsetWidth - 36;
            //
            // let fullRate = rickBoxWidth / aWindowWidth;
            //
            // console.log("===================", aWindowWidth * fullRate , aWindowHeight * fullRate)
            //
            // iframe.style.width = (aWindowWidth * fullRate) + "px";
            // iframe.style.height = (aWindowHeight * fullRate) + "px";

          }

        })


      }
    },
    swiperNext() {
      this.$refs.mySwiper.swiper.slideNext()
    },
    swiperPrev() {
      this.$refs.mySwiper.swiper.slidePrev()
    },
    swiperNextRich() {
      this.$refs.mySwiperRich.swiper.slideNext()
    },
    swiperPrevRich() {
      this.$refs.mySwiperRich.swiper.slidePrev()
    },

  },
  beforeRouteUpdate(to, from, next) {
    this.showNewsDetail = false;
    this.openType = 0;
    this.asidId = to.query.id;
    this.getFuncList();
    next((vm) => {});
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
    swiperRich() {
      return this.$refs.mySwiperRich.swiper;
    },
  },
  mounted() {
    window.addEventListener("resize", this.handleResize);
  },
};
</script>

<style lang="scss" scoped>
.background-image {
  min-width: 120rem; /* 设置div的宽度 */
  margin: 0 12rem;
  height: 100%; /* 设置div的高度 */
  background-clip: content-box;
  background-repeat: no-repeat;
  background-position: center; /* 背景图片居中 */
  color: #fff;
  background-size: 100% 100%;
}
::v-deep .el-carousel__indicators {
  display: flex;
  flex-direction: row;
  flex-wrap: nowrap;
}

.banner-block {
  display: flex;
  flex-direction: column;

  .background-image-bgbox{
    min-width: 120rem; /* 设置div的宽度 */
    width: 100%;
    height: 100%; /* 设置div的高度 */
    .background-image-bg{
      width: 100%;
      height: 100%;
      position: relative;
    }
  }
  .carousel_title {
    margin: 85px 0 0 38px;
    font-size: 40px;
    min-height: 52px;
    width: 90vw;
    line-height: normal;
    font-weight: 700;
  }
  .carousel_description {
    margin: 6px 0 0 38px;
    font-size: 18px;
    width: 90vw;
    line-height: normal;
    min-height: 52px;
    font-weight: 400;
  }
  .carousel_button {
    margin: 22px 0 0 38px;
    font-size: 14px;
    width: 90vw;
    min-height: 52px;
    font-weight: 400;
  }
}

.background-image::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背景下 */
}

.breadcrumb-search {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 120rem;
  margin: 20px 12rem 20px 12rem;

  .breadcrumb-block {
    width: 100%;
    font-weight: 400;
    display: flex;
    flex-direction: row;
    justify-content: center;
    .breadcrumb-block-content{
      width: 96rem;
      .el-breadcrumb {
        height: 20px;
        span {
          font-size: 14px;
          width: 85px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }

      .custom-bead-box{
        padding-left: 30px;
        display: flex;
        flex-direction: row;
        .bead-box-item{
          cursor: pointer;
          display: flex;
          flex-direction: row;
          align-items: center;
          font-size: 14px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
          flex-shrink: 0;

          .bead-box-item-line{
            width: 1px;
            height: 9px;
            margin: 0 10px;
            background-color: #DFDFDF;
          }

        }

        .bead-box-item-active {
          color: #939395;
        }

      }

    }

  }
  .search-block {
    margin-right: 16rem;
    width: 290px;
    height: 32px;
    .search-input {
      margin-top: -4px;
      .el-input__inner {
      }
      .serach-button {
        background-color: #255077;
        height: 100%;
      }
    }
  }
}

.page-content {
  display: flex;
  flex-direction: row;
  width: 120rem;
  justify-content: flex-start;
  .asid-menu-block {
    flex-shrink: 0;
    width: 20rem;
    border-bottom: 0px;
    margin-bottom: 20px;
    ul {
      border-left: 2px solid #255077;
      border-right: 0;
      .el-menu-item {
        font-weight: 400;
        font-size: 20px !important;
        color: #6f7288 !important;
      }
      .is-active {
        background-color: #fff !important;
        color: #255077 !important;
        border-top: 2px solid #f9f9fa;
        border-left: 2px solid #f9f9fa;
        border-bottom: 2px solid #f9f9fa;
        font-weight: bolder !important;
        position: relative;
        &::after {
          width: 6px;
          height: 6px;
          border-top: 2px solid;
          border-right: 2px solid;
          border-color: #255077;
          content: "";
          position: absolute;
          left: 120px;
          top: 26px;
          transform: rotate(45deg);
        }
      }
    }
  }
  .asid-hor-menu-block {
    margin-bottom: 20px;
    width: 128rem;
    .el-menu--horizontal {
      display: flex;
      flex-direction: row;
      justify-content: space-around;
      div {
        width: 40rem;
        .el-menu-item {
          font-size: 13px !important;
          font-weight: 400;
          color: #74727d;
          text-align: center;
        }
        .is-active {
          background-color: #fff !important;
          font-weight: 700 !important;
          font-size: 13px !important;
          border-bottom: 2px solid #2e4d75;
          span {
            color: #255077 !important;
          }
          :hover {
            span {
              text-decoration: underline;
            }
          }
        }
      }
    }
  }
  .content-block {
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;

    .content-block-layout{
      display: flex;
      flex-direction: column;
      width: 96rem;
      .content-block-item {
        display: flex;
        flex-direction: row;
        .content-icon {
          width: 262px;
          height: 160px;
          flex-shrink: 0;
        }
        .content-item {
          margin-left: 20px;
          height: 160px;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          align-items: start;
          background-color: #f7f7f7;
          border-radius: 6px;
          margin-bottom: 20px;
          flex: 1;
          &:hover {
            background-color: #edeef5;
          }
          .title-detail {
            display: flex;
            flex-direction: column;
            justify-content: start;
            .content-item-title {
              font-weight: 700;
              color: #050d33;
              font-size: 16px;
              height: 23px;
              width: 66rem;
              padding: 16px 16px 8px 16px;
              line-height: 23px;
            }
            .content-item-detail {
              font-size: 14px;
              font-weight: 400;
              width: 66rem;
              height: 60px;
              line-height: 20px;
              margin-left: 16px;
              display: -webkit-box;
              -webkit-line-clamp: 3;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }

          .content-item-opTime {
            width: 50px;
            align-self: flex-end;
            font-size: 12px;
            margin-bottom: 6px;
            font-weight: 400;
            line-height: normal;
            color: #5c758a;
          }
        }
      }

      .pagination-block{
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: center;
      }

    }

  }

  .rich-content{
    flex: 1;
    display: flex;
    flex-direction: column;
    align-items: center;
    .rich-box{
      display: flex;
      flex-direction: column;
      width: calc(96rem * 0.75);
      .html-block {
        width: 100%;
        margin-top: 20px;
        font-size: 19px;
        padding: 19px;

        letter-spacing: 0.2px;
        line-height: 31px;
        word-wrap: break-word;
        box-sizing: border-box;
        text-align: justify;

      }

      .html-title{
        font-size: 22px;
        font-weight: 900;
        text-align: center;
      }
    }
  }

}

.html-block {
  border: 1px solid #f1f1f1;
}
@media only screen and (max-width: 1920px) {
}

@media only screen and (max-width: 1439px) {
  .background-image {
    width: 100%;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 0 auto;
    height: 100%; /* 设置div的高度 */
  }

  .contain-block {
    width: 120rem;
    min-width: 0;
    max-width: 1200px; /* 设置div的宽度 */
    margin: 40px 12rem 0 0;
  }

  .page-content {
    .rich-content{
      .rich-box{
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .rich-swiper-box{
        width: 100%;
        margin-top: 40px;

        .rich-banner-block {
          display: flex;
          flex-direction: column;
          height: 100%; /* 设置div的高度 */
          .rich-background-image-bgbox{
            width: 100%;
            height: 100%; /* 设置div的高度 */
            .rich-background-image-bg{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .rich-custom-carousel{
          :deep(.swiper-button-prev){
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(10%);
            opacity: 1;
            background: rgba(0,0,0,0.3);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(10%);
            background: rgba(0,0,0,0.3);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

        }

      }

    }
  }

}
@media only screen and (max-width: 1330px) {
  .page-content {
    .rich-content{
      .rich-box{
        display: flex;
        flex-direction: column;
        width: 100%;

      }

      .rich-swiper-box{
        width: 100%;
        margin-top: 40px;

        .rich-banner-block {
          display: flex;
          flex-direction: column;
          height: 100%; /* 设置div的高度 */
          .rich-background-image-bgbox{
            width: 100%;
            height: 100%; /* 设置div的高度 */
            .rich-background-image-bg{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .rich-custom-carousel{
          :deep(.swiper-button-prev){
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(10%);
            opacity: 1;
            background: rgba(0,0,0,0.3);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(10%);
            background: rgba(0,0,0,0.3);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

        }

      }

    }
  }

}
@media only screen and (max-width: 1200px) {
  .page-content {
    .rich-content{
      .rich-box{
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .rich-swiper-box{
        width: 100%;
        margin-top: 40px;

        .rich-banner-block {
          display: flex;
          flex-direction: column;
          height: 100%; /* 设置div的高度 */
          .rich-background-image-bgbox{
            width: 100%;
            height: 100%; /* 设置div的高度 */
            .rich-background-image-bg{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .rich-custom-carousel{
          :deep(.swiper-button-prev){
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(10%);
            opacity: 1;
            background: rgba(0,0,0,0.3);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(10%);
            background: rgba(0,0,0,0.3);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

        }

      }


    }
  }

}
@media only screen and (max-width: 992px) {

  .page-content {
    .rich-content{
      .rich-box{
        display: flex;
        flex-direction: column;
        width: 100%;
      }

      .rich-swiper-box{
        width: 100%;
        margin-top: 40px;

        .rich-banner-block {
          display: flex;
          flex-direction: column;
          height: 100%; /* 设置div的高度 */
          .rich-background-image-bgbox{
            width: 100%;
            height: 100%; /* 设置div的高度 */
            .rich-background-image-bg{
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
        }

        .rich-custom-carousel{
          :deep(.swiper-button-prev){
            display: flex !important;
            justify-content: center;
            align-items: center;
            width: 36px;
            height: 36px;
            top: 50%;
            transform: translateY(10%);
            opacity: 1;
            background: rgba(0,0,0,0.3);
            .el-icon-arrow-left{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

          :deep(.swiper-button-next){
            display: flex !important;
            width: 36px;
            height: 36px;
            top: 50%;
            border-radius: 18px;
            transform: translateY(10%);
            background: rgba(0,0,0,0.3);
            opacity: 1;
            .el-icon-arrow-right{
              width: auto;
              height: auto;
              font-size: 18px;
              display: block;
            }
          }

        }

      }


    }
  }

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }


  .breadcrumb-search {
    flex-direction: column;
    justify-content: start;
    align-items: start;
    .breadcrumb-block {
      width: 280px;
      font-weight: 400;
      display: flex;
      margin-left: 0;
      flex-direction: row;
      .el-breadcrumb {
        span {
          font-size: 14px;
          width: 85px;
          height: 20px;
          color: #0e517a;
          line-height: 20px;
        }
      }
    }
    .search-block {
      width: 120rem;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      div {
        width: 290px;
        height: 32px;
        .search-input {
          .serach-button {
            background-color: #255077;
            height: 100%;
          }
        }
      }
    }
  }

  .common-block {
    margin: 0 12rem;
    width: 120rem;
  }
  .page-content {
    .asid-menu-block {
      ul {
        .el-menu-item {
          font-weight: 400;
          font-size: 12px !important;
          color: #6f7288 !important;
          position: relative;
        }
        .is-active {
          &::after {
            left: 70px;
          }
        }
      }
    }
    .content-block {
      width: 128rem;
      margin-left: 0;
      .content-block-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
        .content-block-item {
          .content-icon {
            width: 229px;
            height: 140px;
          }
          .content-item {
            height: 140px;
            .title-detail {
              .content-item-title {
                width: 66rem;
                font-size: 14px;
                padding: 12px 16px;
              }
              .content-item-detail {
                font-size: 14px;
                font-weight: 400;
                width: 66rem;
                height: 60px;
              }
            }
          }
        }
      }

    }
  }
}
@media only screen and (max-width: 768px) {

  .page-content {

    .rich-swiper-box{
      width: 100%;
      margin-top: 40px;

      .rich-banner-block {
        display: flex;
        flex-direction: column;
        height: 100%; /* 设置div的高度 */
        .rich-background-image-bgbox{
          width: 100%;
          height: 100%; /* 设置div的高度 */
          .rich-background-image-bg{
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
      }

      .rich-custom-carousel{
        :deep(.swiper-button-prev){
          display: flex !important;
          justify-content: center;
          align-items: center;
          width: 36px;
          height: 36px;
          top: 50%;
          transform: translateY(10%);
          opacity: 1;
          background: rgba(0,0,0,0.3);
          .el-icon-arrow-left{
            width: auto;
            height: auto;
            font-size: 18px;
            display: block;
          }
        }

        :deep(.swiper-button-next){
          display: flex !important;
          width: 36px;
          height: 36px;
          top: 50%;
          border-radius: 18px;
          transform: translateY(10%);
          background: rgba(0,0,0,0.3);
          opacity: 1;
          .el-icon-arrow-right{
            width: auto;
            height: auto;
            font-size: 18px;
            display: block;
          }
        }

      }

    }

  }

  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }



  .breadcrumb-search {
    width: 128rem;
    margin: 20px 8rem 20px 8rem;
    .search-block {
      width: 128rem;
    }
  }

  .page-content {
    flex-direction: column;
    .asid-menu-block {
      width: 90px;
    }
    .content-block {
      margin-right: 8rem;
      margin-left: 8rem;
      .content-block-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
        .content-block-item {
          .content-icon {
            width: 140px;
            height: 140px;
            margin-left: 0;
          }
          .content-item {
            height: 140px;
            margin-left: 6px;
            .title-detail {
              .content-item-title {
                width: 80rem;
                font-size: 14px;
              }
              .content-item-detail {
                font-size: 14px;
                font-weight: 400;
                width: 80rem;
                height: 60px;
              }
            }
          }
        }

      }
    }
    .html-block {
      margin-top: 0px;
      font-size: 16px;
    }

    .html-title{
      font-size: 16px;
      margin-bottom: 20px;
    }

  }
  .common-block {
    margin: 0;
    width: 144rem;
    .asid-hor-menu-block{
      margin-right: 8rem;
      margin-left: 8rem;
      width: 128rem;
    }
  }
}
@media only screen and (max-width: 520px) {


  .my-swiper-box{
    .custom-carousel{
      :deep(.swiper-button-prev){
        display: flex !important;
        justify-content: center;
        align-items: center;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.3);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.3);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          font-size: 18px;
          display: block;
        }
      }

    }

  }

  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          &::after {
            left: 100px;
          }
        }
      }
      ul {
        .is-active {
          &::after {
            left: 80px;
          }
        }
      }
    }



    .rich-content{
      flex: 1;
      display: flex;
      flex-direction: column;
      align-items: center;
      .rich-box{
        display: flex;
        flex-direction: column;
        width: 100%;

        .rich-swiper-box{
          width: 100%;
          margin-top: 40px;
          .rich-custom-carousel{
            :deep(.swiper-button-prev){
              display: flex !important;
              justify-content: center;
              align-items: center;
              width: 36px;
              height: 36px;
              top: 50%;
              transform: translateY(10%);
              opacity: 1;
              background: rgba(0,0,0,0.3);
              .el-icon-arrow-left{
                width: auto;
                height: auto;
                font-size: 18px;
                display: block;
              }
            }

            :deep(.swiper-button-next){
              display: flex !important;
              width: 36px;
              height: 36px;
              top: 50%;
              border-radius: 18px;
              transform: translateY(10%);
              background: rgba(0,0,0,0.3);
              opacity: 1;
              .el-icon-arrow-right{
                width: auto;
                height: auto;
                font-size: 18px;
                display: block;
              }
            }

          }

        }

      }
    }


  }

  .page-content {
    .asid-menu-block {
      width: 120px;
      ul {
        .el-menu-item {
          &::after {
            left: 100px;
          }
        }
      }
      ul {
        .is-active {
          &::after {
            left: 80px;
          }
        }
      }
    }

    .content-block {
      width: 128rem;
      box-sizing: border-box;
      .content-block-layout {
        display: flex;
        flex-direction: column;
        width: 100%;
        .content-block-item {
          .content-icon {
            width: 100px;
            height: 100px;
          }
          .content-item {
            width: 90rem;
            height: 100px;
            .title-detail {
              .content-item-title {
                width: 70rem;
                font-size: 14px;
                line-height: 14px;
                height: 14px;
                padding: 8px;
              }
              .content-item-detail {
                width: 86rem;
                height: 40px;
                line-height: 14px;
                font-size: 12px;
                margin: 2px 0 0 8px;
              }
            }
            .content-item-opTime {
              font-size: 12px;
            }
          }
        }
      }
    }
  }
  .pagination-block {
    display: flex;
    flex-direction: row;
    justify-content: center;
    .el-pagination {
      ::v-deep .el-pagination__jump {
        margin-left: 0 !important;
      }
    }
  }
}



.my-swiper-box{
  width: 100%;
  min-width: 120rem; /* 设置div的宽度 */
  height: 100%; /* 设置div的高度 */
  position: relative;

  &:hover {

    :deep(.swiper-button-prev){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      transform: translateY(10%);
      opacity: 1;
      background: rgba(0,0,0,0.1);
      .el-icon-arrow-left{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

    :deep(.swiper-button-next){
      display: flex !important;
      width: 36px;
      height: 36px;
      top: 50%;
      border-radius: 18px;
      transform: translateY(10%);
      background: rgba(0,0,0,0.1);
      opacity: 1;
      .el-icon-arrow-right{
        width: auto;
        height: auto;
        display: inline-block;
      }
    }

  }



  :deep(.swiper-button-prev){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 18px;
    background: rgba(0,0,0,0);
    opacity: 0;
    top: 50%;
    transform: translateY(10%);

    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-left{
      width: 0;
      height: 0;
      display: none;
    }

  }

  :deep(.swiper-button-next){

    //display: none !important;
    transition: all 0.2s ease-in-out;
    width: 0px;
    height: 0px;
    display: flex;
    opacity: 0;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    line-height: normal;
    border-radius: 1.8rem;
    background: rgba(0,0,0,0);
    top: 50%;
    transform: translateY(10%);
    &:after {
      font-size: 1.1rem;
      color: #fff;

    }

    .el-icon-arrow-right{
      width: 0;
      height: 0;
      display: none;
    }

  }


}

.rich-content{

  .rich-swiper-box{
    width: calc(96rem * 0.75);
    position: relative;
    margin-top: 40px;

    .rich-banner-block {
      width: 100%;
      display: flex;
      flex-direction: column;
      height: 100%; /* 设置div的高度 */
      .rich-background-image-bgbox{
        width: 100%;
        height: 100%; /* 设置div的高度 */
        .rich-background-image-bg{
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
      }
    }

    &:hover {

      :deep(.swiper-button-prev){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        transform: translateY(10%);
        opacity: 1;
        background: rgba(0,0,0,0.1);
        .el-icon-arrow-left{
          width: auto;
          height: auto;
          display: inline-block;
        }
      }

      :deep(.swiper-button-next){
        display: flex !important;
        width: 36px;
        height: 36px;
        top: 50%;
        border-radius: 18px;
        transform: translateY(10%);
        background: rgba(0,0,0,0.1);
        opacity: 1;
        .el-icon-arrow-right{
          width: auto;
          height: auto;
          display: inline-block;
        }
      }

    }



    :deep(.swiper-button-prev){

      //display: none !important;
      transition: all 0.2s ease-in-out;
      width: 0px;
      height: 0px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: normal;
      border-radius: 18px;
      background: rgba(0,0,0,0);
      opacity: 0;
      top: 50%;
      transform: translateY(10%);

      &:after {
        font-size: 1.1rem;
        color: #fff;

      }

      .el-icon-arrow-left{
        width: 0;
        height: 0;
        display: none;
      }

    }

    :deep(.swiper-button-next){

      //display: none !important;
      transition: all 0.2s ease-in-out;
      width: 0px;
      height: 0px;
      display: flex;
      opacity: 0;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      line-height: normal;
      border-radius: 1.8rem;
      background: rgba(0,0,0,0);
      top: 50%;
      transform: translateY(10%);
      &:after {
        font-size: 1.1rem;
        color: #fff;

      }

      .el-icon-arrow-right{
        width: 0;
        height: 0;
        display: none;
      }

    }


  }

}

.my-swiper-box-bg{
  width: 100%;
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-image: var(--bgImage);
  background-size: 100% 100%;
  opacity: 1; /* 设置透明度 */
  z-index: -1; /* 确保伪元素在背 下 */
}

:deep(.swiper-pagination){
  bottom: 7px;
}
/* Swiper指示器的自定义样式 */
:deep(.swiper-pagination-bullet) {

  opacity: .48;
  width: 30px;
  height: 2px;
  background-color: #fff;
  border-radius: 10px;
  /* 其他样式按需修改 */
}

:deep(.swiper-pagination-bullet-active) {
  background-color: #fff;
  opacity: 1;
  /* 激活状态下的样式按需修改 */
}


</style>
